export default __webpack_public_path__ + "static/media/Mark-5-HUD-Label.4fd28336.jpg";